import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import { NewUnitsHealthIcon } from '../../HealthIcon';
import { t } from 'i18next';
import {
  BatteryIcon,
  ChipIcon,
  CircleCheckGreen,
  CircleNotCheckRed,
  CircleWarningYellow,
  EnergyNobreakIcon,
  LuzAcesa,
  LuzApagada,
  NobreakOffIcon,
  WifiMiniOffIcon,
  WifiMiniOnIcon,
} from '../../../icons';
import {
  useState, useEffect, useMemo,
} from 'react';
import {
  Card,
  Header,
  ColTitle,
  ColTitleCenter,
  Col,
  ColCenter,
  BodyList,
  CardsContainer,
  Row,
  StyledLink,
  TempColor,
  HealthIndexIcon,
  HealthToolTipDiv,
  SubTitle,
  ToolTipRowTitle,
  ToolTipTitle,
  HealthDesc,
  HealtLastAtt,
  ChevronBottom,
  ChevronTop,
  ButtonTypeSolution,
  ContainerNobreak,
  ContainerTypeOfSolutionsButton,
  NameStyle,
  ColNobreak,
  NameStyleNobreak,
  ExpandTriangle,
  HeaderScrollGutter,
  IconCountWrapper,
  HealthGroupsWrapper,
  SubHeaderLabel,
} from './styles';
import { useStateVar } from '../../../helpers/useStateVar';
import { formatNumberWithFractionDigits } from '~/helpers/thousandFormatNumber';
import { ApiResps } from 'providers';

type GetUnitsListPage = ApiResps['/get-units-list-page']['list'][number];

type Props = {
  devices: {
    devicesHealth: GetUnitsListPage['devices_health'],
    dams: GetUnitsListPage['dams'],
    duts: GetUnitsListPage['duts'],
    vavs: GetUnitsListPage['vavs']
  },
  utilities: {
    nobreaks: GetUnitsListPage['nobreaks']
    illuminations: GetUnitsListPage['illumination']
  }
  machines: GetUnitsListPage['machines'],
  clientId: number,
}

export const Cards = ({
  devices,
  utilities,
  machines,
  clientId,
}: Props): JSX.Element => {
  const { devicesHealth, duts, vavs } = devices;
  const environments = [...duts, ...vavs];
  environments.sort((a, b) => {
    if (a.temprtAlert !== b.temprtAlert) {
      if (a.temprtAlert === 'high' && b.temprtAlert !== 'high') return -1;
      if (a.temprtAlert !== 'high' && b.temprtAlert === 'high') return 1;
      if (a.temprtAlert === 'good' && b.temprtAlert !== 'good') return -1;
      if (a.temprtAlert !== 'good' && b.temprtAlert === 'good') return 1;
      if (a.temprtAlert === 'low' && b.temprtAlert !== 'low') return -1;
      if (a.temprtAlert !== 'low' && b.temprtAlert === 'low') return 1;
    }
    if (a.DEV_ID > b.DEV_ID) return -1;
    if (a.DEV_ID < b.DEV_ID) return 1;
    return 0;
  });

  devicesHealth.sort((a, b) => {
    if (a.H_INDEX !== b.H_INDEX) {
      if (a.H_INDEX === 25 && b.H_INDEX !== 25) return -1;
      if (a.H_INDEX !== 25 && b.H_INDEX === 25) return 1;
      if (a.H_INDEX === 75 && b.H_INDEX !== 75) return -1;
      if (a.H_INDEX !== 75 && b.H_INDEX === 75) return 1;
      if (a.H_INDEX === 50 && b.H_INDEX !== 50) return -1;
      if (a.H_INDEX !== 50 && b.H_INDEX === 50) return 1;
      if (a.H_INDEX === 100 && b.H_INDEX !== 100) return -1;
      if (a.H_INDEX !== 100 && b.H_INDEX === 100) return 1;
      if (a.H_INDEX === null || a.H_INDEX === 2 && b.H_INDEX !== null || b.H_INDEX !== 2) return -1;
      if (a.H_INDEX !== null || a.H_INDEX !== 2 && b.H_INDEX === null || b.H_INDEX === 2) return 1;
      if (a.H_INDEX === 4 && b.H_INDEX !== 4) return -1;
      if (a.H_INDEX !== 4 && b.H_INDEX === 4) return 1;
    }
    if (a.DEV_ID > b.DEV_ID) return -1;
    if (a.DEV_ID < b.DEV_ID) return 1;
    return 0;
  });

  const toggleSortCardEnvironments = (col) => {
    if (col === state.sortColEnvironments) {
      setState({
        sortDirEnvironments: state.sortDirEnvironments === 'asc' ? 'desc' : 'asc',
      });
    } else {
      setState({
        sortColEnvironments: col,
        sortDirEnvironments: 'asc',
      });
    }
  };
  const temperatureIcon = (temperature: number, temprtAlert: string | null): JSX.Element => {
    let color = '#BBBBBB';

    if (temprtAlert === 'low') color = '#2D81FF';
    if (temprtAlert === 'good') color = '#5AB365';
    if (temprtAlert === 'high') color = '#FF0000';
    if (!temprtAlert) color = '#BBBBBB';

    return (
      <TempColor>
        <svg width="14" height="14" style={{ borderRadius: '3px' }}>
          <rect width="14" height="14" style={{ fill: color }} />
        </svg>
        <div>
          { `${formatNumberWithFractionDigits(temperature)}°C` }
        </div>
      </TempColor>
    );
  };

  const [state, render, setState] = useStateVar({
    sortColMachines: 'GROUP_NAME',
    sortDirMachines: 'asc',
    sortColEnvironments: 'ROOM_NAME',
    sortDirEnvironments: 'asc',
    sortColIllumination: 'NAME',
    sortDirIllumination: 'asc',
    sortColNobreak: 'NOBREAK_NAME',
    sortDirNobreak: 'asc',
    typeofSolution: '',
  });

  const bottomEnvironments = state.sortDirEnvironments === 'desc' ? <ChevronBottom /> : <ChevronTop />;

  type TElementSortA = {
    ROOM_NAME: string;
    DEV_ID: string;
    ISVISIBLE: number | null;
    isAuto: boolean;
    status: string;
    temprtAlert: string;
    Temperature: number;
  }

  type TElementSortB = {
    DEV_ID: string;
    GROUP_NAME?: string;
    GROUP_ID?: number;
    ISVISIBLE: number | null;
    ROOM_NAME: string;
    isAuto?: boolean;
    Temperature?: number;
    temprtAlert: string;
    status?: string | null;
  }

  function sortedDevIdDes(hasIconA: boolean, hasIconB: boolean, a: TElementSortA | TElementSortB, b: TElementSortA | TElementSortB) {
    if (state.sortDirEnvironments === 'desc') {
      if (hasIconA && !hasIconB) {
        return 1;
      }
      if (!hasIconA && hasIconB) {
        return -1;
      }
    } else {
      if (hasIconA && !hasIconB) {
        return -1;
      }
      if (!hasIconA && hasIconB) {
        return 1;
      }
    }
    return a[state.sortColEnvironments] < b[state.sortColEnvironments] ? 1 : -1;
  }

  function sortedRoomName(a: TElementSortA | TElementSortB, b: TElementSortA | TElementSortB) {
    if (state.sortDirEnvironments === 'asc') {
      return (a[state.sortColEnvironments] || '').localeCompare((b[state.sortColEnvironments] || ''), undefined, { sensitivity: 'base' });
    }
    return (b[state.sortColEnvironments] || '').localeCompare((a[state.sortColEnvironments] || ''), undefined, { sensitivity: 'base' });
  }

  const sortedEnviroments = environments ? [...environments].sort((a, b) => {
    const hasIconA = a.isAuto && !a.DEV_ID.startsWith('DUT0') && !a.DEV_ID.startsWith('DUT1') && !a.DEV_ID.startsWith('DUT2');
    const hasIconB = b.isAuto && !b.DEV_ID.startsWith('DUT0') && !b.DEV_ID.startsWith('DUT1') && !b.DEV_ID.startsWith('DUT2');

    if (state.sortColEnvironments === 'ROOM_NAME') {
      return sortedRoomName(a, b);
    }

    if (state.sortColEnvironments === 'DEV_ID') {
      return sortedDevIdDes(!!hasIconA, !!hasIconB, a, b);
    }

    if (state.sortDirEnvironments === 'asc') {
      return a[state.sortColEnvironments] < b[state.sortColEnvironments] ? -1 : 1;
    }
    return a[state.sortColEnvironments] < b[state.sortColEnvironments] ? 1 : -1;
  }) : [];

  const isDutQa = (environment: typeof environments[number]): environment is typeof duts[number] => !!(environment as typeof duts[number])?.isDutQA;

  const isClientBB = clientId === 145; // PALIATIVO PARA TIRAR TEMPERATURA DO DUT QA DO BANCO DO BRASIL

  return (
    <CardsContainer>
      <MachineAndUtilityCardUnit
        HealthToolTip={HealthToolTip}
        devices={devices}
        utilities={utilities}
        machines={machines}
      />
      <Card>
        <Header>
          <ColTitle onClick={() => toggleSortCardEnvironments('ROOM_NAME')}>
            {t('ambientes')}
            {state.sortColEnvironments === 'ROOM_NAME' ? bottomEnvironments : ''}
          </ColTitle>
          <ColTitleCenter onClick={() => toggleSortCardEnvironments('DEV_ID')}>
            {t('automacao')}
            {state.sortColEnvironments === 'DEV_ID' ? bottomEnvironments : ''}
          </ColTitleCenter>
          <ColTitleCenter onClick={() => toggleSortCardEnvironments('status')}>
            {t('conexao')}
            {state.sortColEnvironments === 'status' ? bottomEnvironments : ''}
          </ColTitleCenter>
          <ColTitleCenter onClick={() => toggleSortCardEnvironments('Temperature')}>
            {t('tempAtual')}
            {state.sortColEnvironments === 'Temperature' ? bottomEnvironments : ''}
          </ColTitleCenter>
        </Header>
        <BodyList>
          { sortedEnviroments.map((env, index) => (
            <>
              {env.ISVISIBLE === 1 && (
                <Row key={env.ROOM_NAME} style={{ minHeight: 32 }}>
                  <Col to={`/analise/dispositivo/${env.DEV_ID}/informacoes`}>
                    <StyledLink data-tip data-for={`env-${env.ROOM_NAME || env.DEV_ID}-${index}`} to={`/analise/dispositivo/${env.DEV_ID}/informacoes`}>
                      <div style={{
                        overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical',
                      }}
                      >
                        { env.ROOM_NAME }
                      </div>
                    </StyledLink>
                    <ReactTooltip
                      id={`env-${env.ROOM_NAME || env.DEV_ID}-${index}`}
                      place="top"
                      effect="solid"
                      delayHide={100}
                      offset={{ top: 0, left: 10 }}
                      textColor="#000000"
                      border
                      backgroundColor="rgba(255, 255, 255, 0.97)"
                    >
                      { env.ROOM_NAME }
                    </ReactTooltip>
                  </Col>
                  <ColCenter>
                    { (env.isAuto && !env.DEV_ID.startsWith('DUT0') && !env.DEV_ID.startsWith('DUT1') && !env.DEV_ID.startsWith('DUT2'))
                      ? (
                        <StyledLink to={`/analise/dispositivo/${env.DEV_ID}/informacoes`}>
                          { ChipIcon({ color: '#363BC4' }) }
                        </StyledLink>
                      )
                      : '-'}
                  </ColCenter>
                  <ColCenter>
                    { (env.status === 'ONLINE') ? <WifiMiniOnIcon size={17} /> : <WifiMiniOffIcon size={17} /> }
                  </ColCenter>
                  <ColCenter>
                    {env.Temperature && !(isClientBB && isDutQa(env)) ? temperatureIcon(env.Temperature, env.temprtAlert) : '-'}
                  </ColCenter>
                </Row>
              )}
            </>
          ))}
        </BodyList>
      </Card>
    </CardsContainer>
  );
};

type TMachineCardUnit = {
  HealthToolTip: ({ H_INDEX, H_DESC, H_DATE }: {
    H_INDEX: any;
    H_DESC: any;
    H_DATE: any;
  }) => JSX.Element,
  utilities: {
    nobreaks: GetUnitsListPage['nobreaks'],
    illuminations: GetUnitsListPage['illumination']
  },
  devices: {
    devicesHealth: GetUnitsListPage['devices_health'],
    vavs: GetUnitsListPage['vavs'],
    dams: GetUnitsListPage['dams'],
    duts: GetUnitsListPage['duts']
  },
  machines: GetUnitsListPage['machines'],
}

type MachineEntry = GetUnitsListPage['machines'][number];

function MachineAndUtilityCardUnit({
  devices,
  utilities,
  machines,
  HealthToolTip,
}: Readonly<TMachineCardUnit>) {
  const { illuminations, nobreaks } = utilities;
  const [stateMachine, _, setStateMachine] = useStateVar({
    sortColMachines: 'MACHINE_NAME',
    sortDirMachines: 'asc',
    sortColIllumination: 'NAME',
    sortDirIllumination: 'asc',
    sortColNobreak: 'NOBREAK_NAME',
    sortDirNobreak: 'asc',
  });

  const healthPriority: Record<number, number> = {
    25: 0,
    50: 1,
    75: 2,
    100: 3,
    4: 4,
    2: 5,
    0: 6,
  };

  function getWorstHealth(machine: MachineEntry): number | null {
    let worst: number | null = null;
    for (const dev of machine.assets) {
      if (dev.H_INDEX != null) {
        if (worst === null || (healthPriority[dev.H_INDEX] ?? 99) < (healthPriority[worst] ?? 99)) {
          worst = dev.H_INDEX;
        }
      }
    }
    return worst;
  }

  const sortedMachines = useMemo(() => {
    const list = [...machines];
    list.sort((a, b) => {
      const aHealth = a.assets.some((d) => d.H_INDEX != null);
      const bHealth = b.assets.some((d) => d.H_INDEX != null);
      if (aHealth !== bHealth) return aHealth ? -1 : 1;

      if (stateMachine.sortColMachines === 'MACHINE_NAME') {
        const cmp = (a.MACHINE_NAME || '').localeCompare(b.MACHINE_NAME || '', undefined, { sensitivity: 'base' });
        return stateMachine.sortDirMachines === 'asc' ? cmp : -cmp;
      }
      if (stateMachine.sortColMachines === 'DEV_AUTO') {
        const hasA = !!a.DEV_AUTO;
        const hasB = !!b.DEV_AUTO;
        if (hasA !== hasB) return stateMachine.sortDirMachines === 'asc' ? (hasA ? -1 : 1) : (hasA ? 1 : -1);
        return (a.MACHINE_NAME || '').localeCompare(b.MACHINE_NAME || '', undefined, { sensitivity: 'base' });
      }
      if (stateMachine.sortColMachines === 'status') {
        const aOnline = a.assets.filter((d) => d.status === 'ONLINE').length;
        const bOnline = b.assets.filter((d) => d.status === 'ONLINE').length;
        if (aOnline !== bOnline) return stateMachine.sortDirMachines === 'asc' ? bOnline - aOnline : aOnline - bOnline;
        return (a.MACHINE_NAME || '').localeCompare(b.MACHINE_NAME || '', undefined, { sensitivity: 'base' });
      }
      if (stateMachine.sortColMachines === 'H_INDEX') {
        const aWorst = getWorstHealth(a);
        const bWorst = getWorstHealth(b);
        const aPrio = aWorst != null ? (healthPriority[aWorst] ?? 99) : 999;
        const bPrio = bWorst != null ? (healthPriority[bWorst] ?? 99) : 999;
        if (aPrio !== bPrio) return stateMachine.sortDirMachines === 'asc' ? aPrio - bPrio : bPrio - aPrio;
        return (a.MACHINE_NAME || '').localeCompare(b.MACHINE_NAME || '', undefined, { sensitivity: 'base' });
      }
      return 0;
    });
    return list;
  }, [machines, stateMachine.sortColMachines, stateMachine.sortDirMachines]);

  const [expandedMachines, setExpandedMachines] = useState<Set<number>>(new Set());

  function toggleExpand(machineId: number) {
    setExpandedMachines((prev) => {
      const next = new Set(prev);
      if (next.has(machineId)) {
        next.delete(machineId);
      } else {
        next.add(machineId);
      }
      return next;
    });
  }

  const [typeofSolution, setTypeOfSolution] = useState('');

  function comparativeGeneric(constante, name) {
    if (constante === name) return 1;
    return 0;
  }

  function verifyExist(variavel) {
    if (variavel) return 1;
    return 0;
  }

  function sorted(constA, constB) {
    if (stateMachine.sortDirMachines === 'desc') {
      if (constA && !constB) return 1;
      if (!constA && constB) return -1;
    } else {
      if (constA && !constB) return -1;
      if (!constA && constB) return 1;
    }
    return constA < constB ? 1 : -1;
  }

  function ascendSort(a, b) {
    if (stateMachine.sortDirIllumination === 'asc') {
      return a[stateMachine.sortColIllumination] < b[stateMachine.sortColIllumination] ? -1 : 1;
    }
    return a[stateMachine.sortColIllumination] < b[stateMachine.sortColIllumination] ? 1 : -1;
  }

  const sortedIllumination = illuminations ? [...illuminations].sort((a, b) => {
    if (stateMachine.sortColIllumination === 'NAME') {
      if (stateMachine.sortDirIllumination === 'asc') {
        return a[stateMachine.sortColIllumination].localeCompare(b[stateMachine.sortColIllumination], undefined, { sensitivity: 'base' });
      }
      return b[stateMachine.sortColIllumination].localeCompare(a[stateMachine.sortColIllumination], 'pt', { sensitivity: 'base' });
    }
    if (stateMachine.sortColIllumination === 'DEVICE_CODE') {
      const aDevice = verifyExist(a[stateMachine.sortColIllumination]);
      const bDevice = verifyExist(b[stateMachine.sortColIllumination]);
      return sorted(aDevice, bDevice);
    }
    if (stateMachine.sortColIllumination === 'STATUS') {
      const aStatus = comparativeGeneric(a[stateMachine.sortColIllumination], 'ONLINE');
      const bStatus = comparativeGeneric(b[stateMachine.sortColIllumination], 'ONLINE');
      return sorted(aStatus, bStatus);
    }
    return ascendSort(a, b);
  }) : [];

  function renderConnectionIcon(machine: MachineEntry) {
    const assetDevIds = new Set(machine.assets.filter((d) => d.DEV_ID).map((d) => d.DEV_ID));
    const hasDevAuto = machine.DEV_AUTO && !assetDevIds.has(machine.DEV_AUTO);

    let onlineCount = machine.assets.filter((d) => d.DEV_ID && d.status === 'ONLINE').length;
    let offlineCount = machine.assets.filter((d) => d.DEV_ID && d.status !== 'ONLINE').length;

    if (hasDevAuto) {
      if (machine.DEV_AUTO_STATUS === 'ONLINE') onlineCount += 1;
      else offlineCount += 1;
    }

    const totalDevices = onlineCount + offlineCount;
    if (totalDevices === 0) return '-';
    if (totalDevices === 1) {
      return onlineCount > 0 ? <WifiMiniOnIcon size={17} /> : <WifiMiniOffIcon size={17} />;
    }
    return (
      <HealthGroupsWrapper>
        {onlineCount > 0 && (
          <IconCountWrapper>
            <WifiMiniOnIcon size={17} />
            <span>{onlineCount}</span>
          </IconCountWrapper>
        )}
        {offlineCount > 0 && (
          <IconCountWrapper>
            <WifiMiniOffIcon size={17} />
            <span>{offlineCount}</span>
          </IconCountWrapper>
        )}
      </HealthGroupsWrapper>
    );
  }

  function renderHealthIcon(machine: MachineEntry, index: number) {
    const healthDevices = machine.assets.filter((d) => d.H_INDEX != null);
    if (healthDevices.length === 0) return '-';
    if (healthDevices.length === 1) {
      return (
        <>
          <HealthIndexIcon data-tip data-for={`health-machine-${machine.MACHINE_ID}-${index}`}>
            <NewUnitsHealthIcon H_INDEX={healthDevices[0].H_INDEX} />
          </HealthIndexIcon>
          <ReactTooltip
            id={`health-machine-${machine.MACHINE_ID}-${index}`}
            place="top"
            effect="solid"
            delayHide={100}
            offset={{ top: 0, left: 10 }}
            textColor="#000000"
            border
            backgroundColor="rgba(255, 255, 255, 0.97)"
          >
            <HealthToolTip H_INDEX={healthDevices[0].H_INDEX} H_DESC={healthDevices[0].H_DESC} H_DATE={healthDevices[0].H_DATE} />
          </ReactTooltip>
        </>
      );
    }
    const healthOrder = [25, 50, 75, 100, 4, 999, 2];
    const healthGroups: { hIndex: number; count: number }[] = [];
    healthDevices.forEach((d) => {
      const existing = healthGroups.find((g) => g.hIndex === d.H_INDEX);
      if (existing) {
        existing.count += 1;
      } else {
        healthGroups.push({ hIndex: d.H_INDEX!, count: 1 });
      }
    });
    healthGroups.sort((a, b) => healthOrder.indexOf(a.hIndex) - healthOrder.indexOf(b.hIndex));
    return (
      <HealthGroupsWrapper>
        {healthGroups.map((group) => (
          <IconCountWrapper key={group.hIndex}>
            <NewUnitsHealthIcon H_INDEX={group.hIndex} />
            <span>{group.count}</span>
          </IconCountWrapper>
        ))}
      </HealthGroupsWrapper>
    );
  }

  return (
    <Card>
      <HeaderScrollGutter>
        <HeaderMachine state={stateMachine} setState={setStateMachine} />
      </HeaderScrollGutter>
      <BodyList>
        {sortedMachines.map((machine, index) => {
          const isExpandable = machine.assets.length > 0;
          const isExpanded = expandedMachines.has(machine.MACHINE_ID);
          return (
            <div key={machine.MACHINE_ID} style={{ marginBottom: isExpanded ? '6px' : undefined }}>
              <Row style={{ minHeight: 32 }}>
                <Col style={{ flexDirection: 'row', alignItems: 'center', minWidth: 0 }}>
                  {isExpandable ? (
                    <ExpandTriangle onClick={() => toggleExpand(machine.MACHINE_ID)}>
                      {isExpanded ? '▼' : '▶'}
                    </ExpandTriangle>
                  ) : (
                    <div style={{ width: 18, flexShrink: 0 }} />
                  )}
                  <StyledLink
                    data-tip
                    data-for={`machine-${machine.MACHINE_ID}-${index}`}
                    to={`/analise/maquina/${machine.MACHINE_ID}/ativos`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <NameStyle>{machine.MACHINE_NAME || '-'}</NameStyle>
                  </StyledLink>
                  <ReactTooltip
                    id={`machine-${machine.MACHINE_ID}-${index}`}
                    place="top"
                    effect="solid"
                    delayHide={100}
                    offset={{ top: 0, left: 10 }}
                    textColor="#000000"
                    border
                    backgroundColor="rgba(255, 255, 255, 0.97)"
                  >
                    {machine.MACHINE_NAME}
                  </ReactTooltip>
                </Col>
                <ColCenter>
                  {machine.DEV_AUTO ? (
                    <StyledLink to={`/analise/dispositivo/${machine.DEV_AUTO}/informacoes`} target="_blank" rel="noopener noreferrer">
                      {ChipIcon({ color: '#363BC4' })}
                    </StyledLink>
                  ) : '-'}
                </ColCenter>
                <ColCenter>
                  {renderConnectionIcon(machine)}
                </ColCenter>
                <ColCenter>
                  {renderHealthIcon(machine, index)}
                </ColCenter>
              </Row>
              {isExpanded && (
                <div style={{
                  backgroundColor: '#f5f5f5', borderRadius: '4px', padding: '4px 0', position: 'relative',
                }}
                >
                  <Row>
                    <Col style={{ minWidth: 0, flexDirection: 'row', alignItems: 'center' }}>
                      <div style={{ width: 28, flexShrink: 0 }} />
                      <SubHeaderLabel>{t('ativo')}</SubHeaderLabel>
                    </Col>
                    <ColCenter style={{ minWidth: 0 }} />
                    <ColCenter style={{ minWidth: 0 }}>
                      <SubHeaderLabel>{t('conexao')}</SubHeaderLabel>
                    </ColCenter>
                    <ColCenter style={{ minWidth: 0 }}>
                      <SubHeaderLabel>{t('saude')}</SubHeaderLabel>
                    </ColCenter>
                  </Row>
                  {machine.assets.map((asset, devIndex) => (
                    <Row key={asset.ASSET_ID} style={{ position: 'relative' }}>
                      <Col style={{ minWidth: 0, flexDirection: 'row', alignItems: 'center' }}>
                        <div style={{ width: 28, flexShrink: 0 }} />
                        <StyledLink
                          data-tip
                          data-for={`asset-${asset.ASSET_ID}-${devIndex}`}
                          to={`/analise/maquina/${machine.MACHINE_ID}/ativos/${asset.ASSET_ID}/informacoes`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <NameStyle>{asset.ASSET_NAME}</NameStyle>
                        </StyledLink>
                        <ReactTooltip
                          id={`asset-${asset.ASSET_ID}-${devIndex}`}
                          place="top"
                          effect="solid"
                          delayHide={100}
                          offset={{ top: 0, left: 10 }}
                          textColor="#000000"
                          border
                          backgroundColor="rgba(255, 255, 255, 0.97)"
                        >
                          {asset.ASSET_NAME}
                        </ReactTooltip>
                      </Col>
                      <ColCenter style={{ minWidth: 0 }} />
                      <ColCenter style={{ minWidth: 0 }}>
                        {asset.DEV_ID
                          ? (asset.status === 'ONLINE' ? <WifiMiniOnIcon size={17} /> : <WifiMiniOffIcon size={17} />)
                          : '-'}
                      </ColCenter>
                      <ColCenter style={{ minWidth: 0 }}>
                        {asset.H_INDEX != null ? (
                          <>
                            <HealthIndexIcon data-tip data-for={`health-asset-${asset.ASSET_ID}-${devIndex}`}>
                              <NewUnitsHealthIcon H_INDEX={asset.H_INDEX} />
                            </HealthIndexIcon>
                            <ReactTooltip
                              id={`health-asset-${asset.ASSET_ID}-${devIndex}`}
                              place="top"
                              effect="solid"
                              delayHide={100}
                              offset={{ top: 0, left: 10 }}
                              textColor="#000000"
                              border
                              backgroundColor="rgba(255, 255, 255, 0.97)"
                            >
                              <HealthToolTip H_INDEX={asset.H_INDEX} H_DESC={asset.H_DESC} H_DATE={asset.H_DATE} />
                            </ReactTooltip>
                          </>
                        ) : '-'}
                      </ColCenter>
                    </Row>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </BodyList>
      {
        (nobreaks.length > 0 || illuminations.length > 0) && (
          <ContainerNobreak>
            <ButtonsTypeOfSolution
              nobreaks={nobreaks}
              illumination={illuminations}
              typeofSolution={typeofSolution}
              setTypeOfSolution={setTypeOfSolution}
            />
            <BodyList style={{
              marginTop: '45px',
              padding: '0px',
            }}
            >
              <HeaderSolutions state={stateMachine} setState={setStateMachine} typeofSolution={typeofSolution} />
              <BodyList style={{
                border: 'none',
                paddingLeft: typeofSolution === 'nobreak' ? 24 : 7,
              }}
              >
                <TypeSolutionNobreak typeofSolution={typeofSolution} nobreaks={nobreaks} />
                <TypeSolutionIllumination typeofSolution={typeofSolution} sortedIllumination={sortedIllumination} />
              </BodyList>
            </BodyList>
          </ContainerNobreak>
        )
      }
    </Card>
  );
}

function TypeSolutionNobreak({ typeofSolution, nobreaks }) {
  return (
    <>
      { typeofSolution === 'nobreak' && nobreaks.map((item, index) => (
        <Row key={item.DEV_ID} style={{ minHeight: 32 }}>
          <ColNobreak>
            <StyledLink
              data-tip
              data-for={`nobreak-${item.NOBREAK_NAME || item.NOBREAK_ID}-${index}`}
              to={`/analise/utilitario/nobreak/${item.NOBREAK_ID}/informacoes`}
            >
              <NameStyleNobreak>{item.NOBREAK_NAME}</NameStyleNobreak>
            </StyledLink>
            <ReactTooltip
              id={`nobreak-${item.NOBREAK_NAME || item.NOBREAK_ID}-${index}`}
              place="top"
              effect="solid"
              delayHide={100}
              offset={{ top: 0, left: 10 }}
              textColor="#000000"
              border
              backgroundColor="rgba(255, 255, 255, 0.97)"
            >
              { item.NOBREAK_NAME }
            </ReactTooltip>
          </ColNobreak>
          <ColCenter>
            { item.DMT_CODE ? (
              <StyledLink to={`/analise/dispositivo/${item.DMT_CODE}/informacoes`}>
                { ChipIcon({ color: '#363BC4' }) }
              </StyledLink>
            )
              : '-'}
          </ColCenter>
          <ColCenter>
            {
              item.STATUS === 'Rede Elétrica' && (
                <EnergyNobreakIcon />
              )
            }
            {
              item.STATUS === 'Bateria' && (
                <BatteryIcon />
              )
            }
            {
              item.STATUS === 'Desligado' && (
                <NobreakOffIcon color="#CFCFCF" />
              )
            }
            {
              (item.STATUS !== 'Desligado' && item.STATUS !== 'Sem luz' && item.STATUS !== 'Com luz') && (
                '-'
              )
            }
          </ColCenter>
          <ColCenter>
            { item.AVERAGEDUR ? (
              <>{`${item.AVERAGEDUR}min`}</>
            )
              : '-'}
          </ColCenter>
          <ColCenter>
            {
              !item.AUTON && (
                '-'
              )
            }
            {
              (item.AUTON) && (
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '70%',
                }}
                >
                  {
                    (Number(item.AUTON) < 70 && Number(item.AUTON) >= 30) && (
                      <CircleWarningYellow />
                    )
                  }
                  {
                    (Number(item.AUTON) > 70) && (
                      <CircleCheckGreen />
                    )
                  }
                  {
                    (Number(item.AUTON) < 30) && (
                      <CircleNotCheckRed />
                    )
                  }
                  {`${Number(item.AUTON)}%`}
                </div>
              )
            }
          </ColCenter>
          <ColCenter>
            { (item.CONNECTION === 'ONLINE') ? <WifiMiniOnIcon size={17} /> : <WifiMiniOffIcon size={17} /> }
          </ColCenter>
        </Row>
      ))}
    </>
  );
}

function TypeSolutionIllumination({ typeofSolution, sortedIllumination }) {
  function returnStatusIconIllumination(status) {
    if (status === 'Ligado') {
      return <LuzAcesa />;
    }
    if (status === 'Desligado') {
      return <LuzApagada />;
    }
    return '-';
  }
  return (
    <>
      { typeofSolution === 'illumination' && sortedIllumination.map((item, index) => (
        <Row
          key={`${item.DEVICE_CODE}${item.ID}${item.NAME}`}
          style={{
            minHeight: 32,
            paddingLeft: typeofSolution === 'nobreak' ? 18 : 10,
          }}
        >
          <Col>
            <StyledLink data-tip data-for={`illumination-${item.NAME || item.ID}-${index}`} to={`/analise/utilitario/iluminacao/${item.ID}/informacoes`}>
              <NameStyle>{item.NAME}</NameStyle>
            </StyledLink>
            <ReactTooltip
              id={`illumination-${item.NAME || item.ID}-${index}`}
              place="top"
              effect="solid"
              delayHide={100}
              offset={{ top: 0, left: 10 }}
              textColor="#000000"
              border
              backgroundColor="rgba(255, 255, 255, 0.97)"
            >
              { item.NAME }
            </ReactTooltip>
          </Col>
          <ColCenter
            style={{
              marginLeft: 10,
            }}
          >
            { item?.DEVICE_CODE ? (
              <StyledLink to={`/analise/dispositivo/${item.DEVICE_CODE}/informacoes`}>
                { ChipIcon({ color: '#363BC4' }) }
              </StyledLink>
            )
              : '-'}
          </ColCenter>
          <ColCenter>
            {returnStatusIconIllumination(item.STATUS)}
          </ColCenter>
          <ColCenter>
            { (item.CONNECTION === 'ONLINE') ? <WifiMiniOnIcon size={17} /> : <WifiMiniOffIcon size={17} /> }
          </ColCenter>
        </Row>
      ))}
    </>
  );
}

function HeaderMachine({ state, setState }) {
  const bottomMachines = state.sortDirMachines === 'desc' ? <ChevronBottom /> : <ChevronTop />;
  const toggleSortCardMachines = (col) => {
    if (col === state.sortColMachines) {
      setState({
        sortDirMachines: state.sortDirMachines === 'asc' ? 'desc' : 'asc',
      });
    } else {
      setState({
        sortColMachines: col,
        sortDirMachines: 'asc',
      });
    }
  };
  return (
    <Header>
      <ColTitle onClick={() => toggleSortCardMachines('MACHINE_NAME')}>
        {t('maquinas')}
        {state.sortColMachines === 'MACHINE_NAME' ? bottomMachines : ''}
      </ColTitle>
      <ColTitleCenter onClick={() => toggleSortCardMachines('DEV_AUTO')}>
        {t('automacao')}
        {state.sortColMachines === 'DEV_AUTO' ? bottomMachines : ''}
      </ColTitleCenter>
      <ColTitleCenter onClick={() => toggleSortCardMachines('status')}>
        {t('conexao')}
        {state.sortColMachines === 'status' ? bottomMachines : ''}
      </ColTitleCenter>
      <ColTitleCenter onClick={() => toggleSortCardMachines('H_INDEX')}>
        {t('saude')}
        {state.sortColMachines === 'H_INDEX' ? bottomMachines : ''}
      </ColTitleCenter>
    </Header>
  );
}

function ButtonsTypeOfSolution({
  nobreaks,
  illumination,
  typeofSolution,
  setTypeOfSolution,
}) {
  const arraySolutions = [
  ] as { solution: string, label: string }[];

  if (nobreaks.length > 0) {
    arraySolutions.push({
      solution: 'nobreak',
      label: 'Nobreak',
    });
  }

  if (illumination.length > 0) {
    arraySolutions.push({
      solution: 'illumination',
      label: 'Iluminação',
    });
  }

  useEffect(() => {
    setTypeOfSolution(arraySolutions[0].solution);
  }, []);

  return (
    <ContainerTypeOfSolutionsButton>
      {
        arraySolutions.map((item) => (
          <ButtonTypeSolution
            key={item.label}
            onClick={() => { setTypeOfSolution(item.solution); }}
            isClicked={typeofSolution === item.solution}
          >
            {item.label}
          </ButtonTypeSolution>
        ))
      }
    </ContainerTypeOfSolutionsButton>
  );
}

function HeaderSolutions({ state, setState, typeofSolution }) {
  const bottomIllumination = state.sortDirIllumination === 'desc' ? <ChevronBottom /> : <ChevronTop />;
  const toggleSortCardIllumination = (col) => {
    if (col === state.sortColIllumination) {
      setState({
        sortDirIllumination: state.sortDirIllumination === 'asc' ? 'desc' : 'asc',
      });
    } else {
      setState({
        sortColIllumination: col,
        sortDirIllumination: 'asc',
      });
    }
  };

  const arrayHeaderNobreak = [
    {
      label: 'Monit.',
      value: 'monit',
    },
    {
      label: 'Status',
      value: 'status',
    },
    {
      label: 'Dur. Média',
      value: 'averageDur',
    },
    {
      label: 'Autonomia',
      value: 'autonomy',
    },
    {
      label: 'Conexão',
      value: 'conection',
    },
  ];

  const arrayHeaderIllumination = [
    {
      value: 'DEVICE_CODE',
      label: 'Dispositivo',
      onClick: () => toggleSortCardIllumination('DEVICE_CODE'),
    },
    {
      value: 'STATUS',
      label: 'Status',
      onClick: () => toggleSortCardIllumination('STATUS'),
    },
    {
      value: 'CONNECTION',
      label: 'Conexão',
      onClick: () => toggleSortCardIllumination('CONNECTION'),
    },
  ];

  return (
    <Header style={{
      backgroundColor: 'rgba(196, 196, 196, 0.11)',
      width: '100%',
      paddingLeft: typeofSolution === 'nobreak' ? 18 : 10,
      paddingRight: '8px',
    }}
    >
      <ColTitle onClick={() => toggleSortCardIllumination('NAME')}>
        {t('utilitarios')}
        {state.sortColIllumination === 'NAME' ? bottomIllumination : ''}
      </ColTitle>
      {
        typeofSolution === 'nobreak' && (
          arrayHeaderNobreak.map((item) => (
            <ColTitleCenter
              key={item.label}
            >
              {item.label}
            </ColTitleCenter>
          ))
        )
      }
      {
        typeofSolution === 'illumination' && (
          arrayHeaderIllumination.map((item) => (
            <ColTitleCenter
              key={item.label}
              onClick={item.onClick}
            >
              {item.label}
              {state.sortColIllumination === item.value ? bottomIllumination : ''}
            </ColTitleCenter>
          ))
        )
      }
    </Header>
  );
}

const HealthToolTip = ({ H_INDEX, H_DESC, H_DATE }): JSX.Element => {
  let title = t('equipamentoOffline');
  if (H_INDEX === 25) title = t('manutencaoUrgente');
  if (H_INDEX === 50) title = t('riscoIminente');
  if (H_INDEX === 75) title = t('foraDeEspecificacao');
  if (H_INDEX === 100) title = t('funcionandoCorretamente');
  if (H_INDEX === 4) title = t('equipamentoDesativado');

  return (
    <HealthToolTipDiv>
      <ToolTipRowTitle>
        <NewUnitsHealthIcon H_INDEX={H_INDEX} />
        <ToolTipTitle>
          { title }
        </ToolTipTitle>
      </ToolTipRowTitle>
      <SubTitle>{t('laudoTecnico')}</SubTitle>
      <HealthDesc>{ H_DESC }</HealthDesc>
      <HealtLastAtt>
        { getLastAtt(H_DATE) }
      </HealtLastAtt>
    </HealthToolTipDiv>
  );

  function getLastAtt(date: string) {
    if (moment().diff(moment(date), 'minutes') < 60) {
      return `${t('haMinutos', { time: moment().diff(moment(date), 'minutes') })}`;
    }
    if (moment().diff(moment(date), 'h') < 24) {
      return `${t('haHoras', { hour: moment().diff(moment(date), 'h'), min: moment().diff(moment(date), 'minutes') })}`;
    }
    if (moment().diff(moment(date), 'd') < 7) {
      return `${t('haDias', { day: moment().diff(moment(date), 'd') })}`;
    }
    if (moment().diff(moment(date), 'weeks') < 4) {
      return `${t('haSemanas', { week: moment().diff(moment(date), 'weeks') })}`;
    }
    if (moment().diff(moment(date), 'months') < 12) {
      return `${t('haMeses', { month: moment().diff(moment(date), 'months') })}`;
    }
    return `${t('haAnos', { year: moment().diff(moment(date), 'y') })}`;
  }
};
